/** @module Enums */ /** typedoc */

/**
 * Intensity used to master.
 * Basic intensities are `Low`, `Medium` and `High`.
 * Extra intensity is `Loud` and lead to some limitations.
 */
export enum IntensityEnum {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
    Loud = 'Loud'
}

